// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RightPanel.module.css */

.RightPanel_rightPanel__rV3f6 {
  flex: 1 1;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.RightPanel_previewHeader__cdtne {
  margin-bottom: 16px;
}

.RightPanel_previewTitle__8U3sA {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 12px;
}
.RightPanel_addGlow__2dQ-q {
  border: 3px solid red;
}

/* ============================================================
   Glow animations for action buttons
   ============================================================ */

@keyframes RightPanel_editBtnGlow__m5EiH {
  0%,
  100% {
    box-shadow:
      0 0 0 0 rgba(66, 164, 225, 0.7),
      0 0 0 0 rgba(66, 135, 225, 0.5);
  }
  50% {
    box-shadow:
      0 0 12px 4px rgba(66, 119, 225, 0.6),
      0 0 24px 8px rgba(66, 122, 225, 0.35);
  }
}

@keyframes RightPanel_wizardBtnGlow__j\\+kms {
  0%,
  100% {
    box-shadow:
      0 0 0 0 rgba(128, 234, 122, 0.7),
      0 0 0 0 rgba(122, 234, 167, 0.5);
  }
  50% {
    box-shadow:
      0 0 12px 4px rgba(122, 234, 148, 0.6),
      0 0 24px 8px rgba(122, 234, 154, 0.35);
  }
}

/* Classes that apply the animations */
.RightPanel_editBtnGlow__m5EiH {
  animation: RightPanel_editBtnGlow__m5EiH 2s ease-in-out infinite;
}

.RightPanel_wizardBtnGlow__j\\+kms {
  animation: RightPanel_wizardBtnGlow__j\\+kms 2s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewTester/components/RightPanel.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;;iEAEiE;;AAEjE;EACE;;IAEE;;qCAEiC;EACnC;EACA;IACE;;2CAEuC;EACzC;AACF;;AAEA;EACE;;IAEE;;sCAEkC;EACpC;EACA;IACE;;4CAEwC;EAC1C;AACF;;AAEA,sCAAsC;AACtC;EACE,gEAA8C;AAChD;;AAEA;EACE,mEAAgD;AAClD","sourcesContent":["/* RightPanel.module.css */\n\n.rightPanel {\n  flex: 1;\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.previewHeader {\n  margin-bottom: 16px;\n}\n\n.previewTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 12px;\n}\n.addGlow {\n  border: 3px solid red;\n}\n\n/* ============================================================\n   Glow animations for action buttons\n   ============================================================ */\n\n@keyframes editBtnGlow {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 0 rgba(66, 164, 225, 0.7),\n      0 0 0 0 rgba(66, 135, 225, 0.5);\n  }\n  50% {\n    box-shadow:\n      0 0 12px 4px rgba(66, 119, 225, 0.6),\n      0 0 24px 8px rgba(66, 122, 225, 0.35);\n  }\n}\n\n@keyframes wizardBtnGlow {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 0 rgba(128, 234, 122, 0.7),\n      0 0 0 0 rgba(122, 234, 167, 0.5);\n  }\n  50% {\n    box-shadow:\n      0 0 12px 4px rgba(122, 234, 148, 0.6),\n      0 0 24px 8px rgba(122, 234, 154, 0.35);\n  }\n}\n\n/* Classes that apply the animations */\n.editBtnGlow {\n  animation: editBtnGlow 2s ease-in-out infinite;\n}\n\n.wizardBtnGlow {\n  animation: wizardBtnGlow 2s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `RightPanel_rightPanel__rV3f6`,
	"previewHeader": `RightPanel_previewHeader__cdtne`,
	"previewTitle": `RightPanel_previewTitle__8U3sA`,
	"addGlow": `RightPanel_addGlow__2dQ-q`,
	"editBtnGlow": `RightPanel_editBtnGlow__m5EiH`,
	"wizardBtnGlow": `RightPanel_wizardBtnGlow__j+kms`
};
export default ___CSS_LOADER_EXPORT___;
